import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTibet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1357)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23657 2.08697C7.16243 0.770437 9.49108 0 12 0C14.509 0 16.8376 0.770437 18.7635 2.08697L12 2.60869L5.23657 2.08697Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51534 20.4847L9.04856 14.9515L12 9.91304L14.9511 14.9512L20.4847 20.4847C22.6564 18.3132 24 15.3137 24 12C24 7.88152 21.9249 4.24805 18.7635 2.08698H5.23655C2.07511 4.24805 0 7.88152 0 12C0 15.3137 1.34363 18.3132 3.51534 20.4847Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.0884 16.5947L14.3148 12.9592L14.9507 14.9506L20.4847 20.4846C21.5896 19.3798 22.4802 18.0607 23.0884 16.5947Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 10.3723 23.6756 8.82048 23.0884 7.40527L12 12H24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4847 3.51535C19.9572 2.98801 19.3812 2.50927 18.7635 2.08698H16.1077L12 12L20.4847 3.51535Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 2.08698H7.89233L12 12V2.08698Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51529 3.51535C2.41036 4.62019 1.51987 5.9393 0.911621 7.40523L11.9999 12L3.51529 3.51535Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 13.6277 0.324422 15.1795 0.911625 16.5947L12 12H0Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23657 21.913C7.16238 23.2296 9.49108 24 12 24C14.509 24 16.8376 23.2296 18.7635 21.913H5.23657Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0001 12L14.9515 14.9514C15.7068 14.196 16.174 13.1526 16.174 12C16.174 9.69478 14.3053 7.82611 12.0001 7.82611C9.69494 7.82611 7.82617 9.69478 7.82617 12C7.82617 13.1526 8.29333 14.196 9.04872 14.9514L12.0001 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8262 18C13.8262 19.0085 13.0085 19.3043 12.0001 19.3043C10.9916 19.3043 10.174 19.0085 10.174 18C10.174 16.9915 10.9916 16.1739 12.0001 16.1739C13.0085 16.1739 13.8262 16.9915 13.8262 18Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8262 18C13.8262 19.0085 13.0085 19.8261 12.0001 19.8261C10.9916 19.8261 10.174 19.0085 10.174 18",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1357",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTibet;
